export default {"src":"/_next/static/media/icon-long-arrow-white.fe6673d0.svg","height":5,"width":17,"blurWidth":0,"blurHeight":0};